import { Link } from "react-router-dom";
import { Wordmark } from "@/components/brand/Wordmark";
import { WhistllLogo } from "@/components/brand/WhistllLogo";

/**
 * Site footer. Holds brand mark + nav links + the UK Companies Act /
 * ecom regs disclosures: company name, number, registered office.
 * Required on every page under the Companies Act 2006 and the Electronic
 * Commerce (EC Directive) Regulations 2002.
 */
export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border/60 bg-background">
      <div className="mx-auto max-w-6xl px-6 py-10">
        {/* Top row: brand + nav */}
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <WhistllLogo size={18} />
              <Wordmark size="text-lg" />
            </div>
            <p className="text-xs text-muted-foreground">
              Basketball, built for players.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/about" className="hover:text-foreground">
              About Us
            </Link>
            <Link to="/advertise" className="hover:text-foreground">
              Advertise
            </Link>
            <Link to="/community-rules" className="hover:text-foreground">
              Community Rules
            </Link>
            <Link to="/privacy-policy" className="hover:text-foreground">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-foreground">
              Terms of Service
            </Link>
            <Link to="/refunds" className="hover:text-foreground">
              Refunds
            </Link>
            <Link to="/venue-terms" className="hover:text-foreground">
              Venue Partners
            </Link>
            <Link to="/cookie-policy" className="hover:text-foreground">
              Cookies
            </Link>
            <a href="mailto:hello@whistll.com" className="hover:text-foreground">
              Contact
            </a>
          </nav>
        </div>

        {/* Legal / registered-office block. Required on every page for
            UK companies under Companies Act 2006 s.82. */}
        <div className="mt-8 flex flex-col gap-3 border-t border-border/60 pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} <span className="font-semibold text-foreground">Whistll Ltd</span>
            {" "}· Registered in England &amp; Wales, company no.{" "}
            <span className="tabular-nums">17172530</span>.
          </p>
          <p>
            Registered office: 71-75 Shelton Street, Covent Garden, London,
            WC2H 9JQ.
          </p>
        </div>
      </div>
    </footer>
  );
}
